import './ddLogin.scss';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { message } from 'antd';
import { dingdingLogin, getUserLoginInfo } from '../utils/servers';
import actions from '../utils/actions';
import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import { orgUsertree } from '../utils/dataProcessing';
function FcDdLogin(props) {
	const { saveLoginInfo, saveMenus, saveSySMenus, addUserOrgs, addUserInfo } = props;
	const history = useHistory();
	//截取url中的参数
	function getUrlValue(kValue) {
		var url = window.location.href; //当前页面的地址
		var reg = /([^?&=]+)=([^?&=]+)/g;
		var obj = {};
		url.replace(reg, function () {
			obj[arguments[1]] = arguments[2];
		});
		for (var keyName in obj) {
			if (keyName === kValue) {
				return obj[keyName];
			}
		}
	}
	useEffect(() => {
		const searchParams = new URLSearchParams(window.location.search);
		let linkType = searchParams.get('type');
		Cookies.remove('token');
		localStorage.setItem('loginInfo', null);
		localStorage.setItem('myWorkplat', '[]');
		let requestData = {
			code: getUrlValue('code'), // 授权码
			corpId: getUrlValue('corpId'), // 链接截取corpId
			orgId: '',
			loginTarget: 'SYS'
		};
		dingdingLogin(requestData).then((data) => {
			if (data.code === '200') {
				saveLoginInfo(data.data);
				Cookies.set('token', data.data.accessToken);
				localStorage.setItem('loginInfo', JSON.stringify(data.data));
				actions.setGlobalState({ loginInfo: data.data }); //通知主应用并修改initstate
				getUserLoginInfo().then((res) => {
					if (res.code === '200') {
						localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo) || {});
						actions.setGlobalState({ userInfo: res.data.userInfo });
						localStorage.setItem('menus', JSON.stringify(data.data.userRoleFuncList));
						saveMenus(res.data.userRoleFuncList ? res.data.userRoleFuncList : []);
						saveSySMenus(res.data.userRoleFuncList ? res.data.userRoleFuncList : []);
						addUserOrgs(orgUsertree(res.data.userOrgsInfoList) || []);
						addUserInfo(res.data.userInfo || {});
						localStorage.setItem('myWorkplat', JSON.stringify(res.data.userWorkbenchList) || []);
						// addMenusHistory(
						// 	res.data.userWorkbenchList.includes('1276005')
						// 		? [
						// 				{
						// 					path: '/zeus-system/system-permissions/workingPlatform',
						// 					name: '我的工作台',
						// 					parentId: '523523270839386118'
						// 				}
						// 		  ]
						// 		: []
						// );
						history.push('/');
						window.location.reload();
					}
				});
				// 判断路由类型选择跳转页面
				if (linkType === 'mobleLink') {
					history.push('/zeus-system/system-permissions/oaCenter');
				} else {
					history.push('/');
				}
			} else {
				message.error(data.msg || '账号异常，请稍后重试');
			}
		});
	}); // eslint-disable-line react-hooks/exhaustive-deps
	return (
		<div className="ddLogin">
			<div className="ddLoginImg"></div>
			<div className="loginingText">蜂巢灵工平台登录中 . . .</div>
		</div>
	);
}

const mapStateToProps = (state) => {
	return {
		menusHistory: state.menusHistory
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		saveLoginInfo: (info) => dispatch({ type: 'ADD_LOGININFO', info }),
		saveMenus: (info) => dispatch({ type: 'ADD_MENUS', info }),
		addUserOrgs: (info) => dispatch({ type: 'ADD_USERORGS', info }),
		addUserInfo: (info) => dispatch({ type: 'ADD_USERINFO', info }),
		addMenusHistory: (info) => dispatch({ type: 'ADD_MENUSHISTORY', info }),
		saveSySMenus: (info) => dispatch({ type: 'ADD_SYSMENUS', info })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(FcDdLogin);
